export type PrimitiveValue = boolean | undefined | null | number | string;
export type IncrementValue = { increment: "months" | "years" | "days"; offset?: number };

export type RangeValue = PrimitiveValue | IncrementValue;

export type Range = {
  v: RangeValue;
  r: {
    start: string;
    end: string;
  };
};

export type Temporal = {
  ranges: Range[];
  latest?: PrimitiveValue;
};

export type TemporalValue = {
  temporal: Temporal;
};

export type IsTemporal = TemporalValue | Temporal;

export const isTemporal = (arg: any): arg is IsTemporal =>
  typeof arg === "object" && arg !== null && ("temporal" in arg || "ranges" in arg);

export const getValueAtDate = (
  temporalValue: TemporalValue | Temporal | PrimitiveValue | undefined,
  date: any,
): RangeValue => {
  let temporal: Temporal;
  if (temporalValue === undefined || !isTemporal(temporalValue)) {
    return temporalValue as RangeValue;
  }
  if ((temporalValue as TemporalValue)?.temporal) {
    temporal = (temporalValue as TemporalValue).temporal;
  } else {
    temporal = temporalValue as Temporal;
  }
  if (!temporal || !date || !temporal.ranges) return null;
  let value: RangeValue = null;
  const cmpdate = new Date(date);
  for (let i = 0; i < temporal.ranges.length; i++) {
    const r = temporal.ranges[i];
    if (cmpdate <= new Date(r.r.end) && cmpdate >= new Date(r.r.start)) {
      value = r.v;
      break;
    }
  }
  return value;
};


